import { useEffect, useState } from 'react';
import lunarMoonImage from '@/assets/lunar-moon.png';

// Generate random stars
const generateStars = (count: number) => {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 70, // Keep stars in upper portion
    size: Math.random() * 2 + 0.5,
    opacity: Math.random() * 0.5 + 0.2,
    animationDelay: Math.random() * 8,
    animationDuration: Math.random() * 4 + 4,
  }));
};

const LunarMoonBackground = () => {
  const [stars] = useState(() => generateStars(80));
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {/* Black space void */}
      <div className="absolute inset-0 bg-black" />

      {/* Star field */}
      <div className="absolute inset-0">
        {stars.map((star) => (
          <div
            key={star.id}
            className="absolute rounded-full bg-white"
            style={{
              left: `${star.x}%`,
              top: `${star.y}%`,
              width: `${star.size}px`,
              height: `${star.size}px`,
              opacity: star.opacity,
              animation: `starTwinkle ${star.animationDuration}s ease-in-out infinite`,
              animationDelay: `${star.animationDelay}s`,
              boxShadow: `0 0 ${star.size * 2}px rgba(255, 255, 255, 0.5)`,
            }}
          />
        ))}
      </div>

      {/* Distant Earth - very small and subtle */}
      <div
        className="absolute"
        style={{
          width: '30px',
          height: '30px',
          top: '15%',
          right: '20%',
          borderRadius: '50%',
          background: 'radial-gradient(circle at 30% 30%, #4a90d9 0%, #1e5aa8 50%, #0d3a6e 100%)',
          boxShadow: '0 0 20px rgba(74, 144, 217, 0.3), inset -5px -5px 10px rgba(0,0,0,0.3)',
          opacity: 0.7,
        }}
      />

      {/* Moon at the bottom - partially cropped */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2"
        style={{
          width: '120vw',
          maxWidth: '1600px',
          height: 'auto',
          transform: 'translateX(-50%) translateY(40%)',
        }}
      >
        <img
          src={lunarMoonImage}
          alt=""
          className="w-full h-auto opacity-90"
          style={{
            filter: 'brightness(0.85) contrast(1.1)',
          }}
        />
        {/* Subtle glow around the moon */}
        <div
          className="absolute inset-0"
          style={{
            background: 'radial-gradient(ellipse at center top, rgba(150, 150, 160, 0.15) 0%, transparent 50%)',
            pointerEvents: 'none',
          }}
        />
      </div>

      {/* CSS for star animation */}
      <style>{`
        @keyframes starTwinkle {
          0%, 100% { opacity: var(--star-base-opacity, 0.3); }
          50% { opacity: var(--star-peak-opacity, 0.8); }
        }
      `}</style>
    </div>
  );
};

export default LunarMoonBackground;
